import { thor } from "../../typings/thor";
import { Events } from "../../thor.enums";

export class MediaGalleryService {
    public static $inject: string[] = [
        "$mdDialog",
        "$mdMedia",
        "$rootScope",
        "$translate",
        "configService",
        "toaster"
    ];

    public context: string;
    public isOpen: boolean;
    public resource: thor.ItemGet;
    public readOnly: boolean;

    private $t;
    private limit: number;

    constructor(
        private $mdDialog: ng.material.IDialogService,
        private $mdMedia: ng.material.IMedia,
        private $rootScope: ng.IRootScopeService,
        $translate: ng.translate.ITranslateService,
        private configService,
        private toaster
    ) {
        this.$t = $translate.instant;
        this.setLimit();
    }

    public addMedia(event, files: File[], resource?: thor.ItemGet) {
        if (files.length < 1) {
            return;
        }
        if (resource) {
            this.resource = resource;
        }

        const altMediaType: File[] = files.filter(
            (file: File) => file.type !== "image/jpeg" && file.type !== "image/png"
        );

        if (altMediaType.length) {
            return this.toaster.show(this.$t("seuls_les_fichiers_de_type_n_sont_autorises", ["jpg, jpeg, png"]), true);
        }

        const totalMedias: number = resource.medias.length + files.length;

        if (totalMedias > this.limit) {
            return this.toaster.show(this.$t("impossible_d_importer_plus_de_x_images", [this.limit]), true);
        }

        this.$mdDialog
            .show({
                controller: "MediaGallerySidenavUploadMediaController",
                controllerAs: "uploadMediaCtrl",
                template: require("../../shared/media-gallery/media-gallery-sidenav/upload-media-dialog.html"),
                locals: {
                    files,
                    resource
                },
                bindToController: true,
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                fullscreen: this.$mdMedia("xs")
            })
            .then(() => {
                // no check to translations status needed
                if (this.$rootScope.isRouteOnline) {
                    return this.$rootScope.$broadcast(Events.OnlineItemUpdated);
                }
                this.$rootScope.$broadcast(Events.ItemUpdated, resource);
                this.$rootScope.$broadcast(Events.PostMessageToV2);
            });
    }

    public open(resource: thor.ItemGet, context: string, readOnly: boolean) {
        this.context = context;
        this.resource = resource;
        this.isOpen = true;
        this.readOnly = readOnly;
    }

    public close() {
        this.isOpen = false;
        this.context = null;
        this.resource = null;
    }

    protected setLimit() {
        this.limit = this.configService.items.maxImages;
    }
}
